module.exports = __webpack_public_path__ + "static/sizes-d824047328b8be851ff6f2cae7a4d053.png";